import { Component, ChangeDetectionStrategy, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { smoothScrollToElementId } from '@app/shared/utils';
import { GiftsService } from '@app/gifts/services/gifts.service';
import { IGift } from '@app/gifts/models/gift.interface';
import { IGiftsList } from '@app/gifts/models/gifts-list.interface';

@Component({
  selector: 'app-gifts-info',
  templateUrl: './gifts-info.component.html',
  styleUrls: ['./gifts-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftsInfoComponent implements OnInit {
  @Input() visitId: string;
  gifts: IGift[] = [];
  constructor(
    private giftsService: GiftsService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.giftsService.getAvailableGifts(this.visitId, false)
      .subscribe((giftsList: IGiftsList) => {
        this.gifts = giftsList.gifts;
        this.changeDetector.detectChanges();
      });
  }

  scrollToGiftsList(): void {
    smoothScrollToElementId('listOfGiftsScrollToId', 500);
  }

}
